import {
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  GET_CART_FAILURE,
} from "../../constants";
import { createAction, createErrorAction } from "../../utils";

const getCartRequest = createAction(GET_CART_REQUEST);
const getCartSuccess = createAction(GET_CART_SUCCESS);
const getCartFailure = createErrorAction(GET_CART_FAILURE);

export const getCart = () => {
  return (dispatch, getState, { api }) => {
    const { cart } = getState();
    let countryCode = cart.countryCodeFromForm;
    const IPCountry =
      window && window.onecomConfig ? window.onecomConfig.countryCode : null;

    if (!countryCode && IPCountry) {
      countryCode = IPCountry;
    }

    // Load request
    dispatch(getCartRequest());

    // API call
    return api.getCart(countryCode).then(
      (data) => {
        dispatch(getCartSuccess(data));
        window.GTM && window.GTM.pushCartContents(data);
        // Save cart data in session to be used in onecom-js-app
        window.sessionStorage.setItem("cart", JSON.stringify(data));
        // Dispatching event to update cart counter in header, which is maintained in onecom-js-app
        const cartUpdatedEvent = new Event("cartUpdated");
        window.dispatchEvent(cartUpdatedEvent);
      },
      (err) => {
        dispatch(getCartFailure(err));
      },
    );
  };
};
